var cpnBtn1 = document.getElementById("cpnBtn1");

var cpnCode1 = document.getElementById("cpnCode1");

var copyPastew1 = document.getElementById("copyPastew1");

copyPastew1.onclick = function(){

  navigator.clipboard.writeText(cpnCode1.innerHTML);
  
  cpnBtn1.innerHTML = "Copied";
  
  setTimeout(function(){
  
  cpnBtn1.innerHTML = "Tap to copy"; }, 20000);
}

var cpnBtn2 = document.getElementById("cpnBtn2");

var cpnCode2 = document.getElementById("cpnCode2");

var copyPastew2 = document.getElementById("copyPastew2");

copyPastew2.onclick = function(){

  navigator.clipboard.writeText(cpnCode2.innerHTML);
  
  cpnBtn2.innerHTML = "Copied";
  
  setTimeout(function(){
  
  cpnBtn2.innerHTML = "Tap to copy"; }, 20000);
}

var cpnBtn3 = document.getElementById("cpnBtn3");

var cpnCode3 = document.getElementById("cpnCode3");

var copyPastew3 = document.getElementById("copyPastew3");

copyPastew3.onclick = function(){

  navigator.clipboard.writeText(cpnCode3.innerHTML);
  
  cpnBtn3.innerHTML = "Copied";
  
  setTimeout(function(){
  
  cpnBtn3.innerHTML = "Tap to copy"; }, 20000);
}